import { mainApi } from 'services/mainApi'

interface ReadAutoCompleteLocationsParams{
    query: string
}

export const autoCompleteLocationsApi = mainApi
    .enhanceEndpoints({
        addTagTypes:[`AutoCompleteLocations`]
    })
    .injectEndpoints({
        endpoints: (builder) => ({
            readAutoCompleteLocations: builder
            .query({
                query: (params: ReadAutoCompleteLocationsParams) => {
                    let url = `autocomplete?query=${params.query}`
                    return url
                },
                providesTags: (result, error, arg) => ['AutoCompleteLocations'],  
            }),   
    }),
})

export const {
    useReadAutoCompleteLocationsQuery,
    useLazyReadAutoCompleteLocationsQuery,
} = autoCompleteLocationsApi
